import { useCallback, useRef } from 'react';

import { RENDER_DONE_EVENT } from '../utils/variables';

export const useReportInitialLoad = () => {
  const firstRender = useRef<boolean>(true);

  const reportInitialLoad = useCallback(() => {
    if (firstRender.current) {
      firstRender.current = false;
      window.dispatchEvent(new Event(RENDER_DONE_EVENT, { bubbles: true }));
    }
  }, []);

  return reportInitialLoad;
};
